import styled from 'styled-components';

export const Conteiner = styled.div`
  display: flex;
  justify-content: space-between;

  padding: 0 20px;

  background-color: ${(props) => props.theme.LIGHT};
`;

export const AreaUsuario = styled.div`
  display: flex;
  align-items: center;

  #botao-deslogar {
    width: 25px;
    height: 25px;
    padding: 5px;
  }
`;

export const NomeUsuario = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
`;

export const ConteinerPerfis = styled.div`
  position: absolute;
  top: 45px;
  left: 8%;

  height: 0;
  padding: 0px 5px;

  background-color: ${(props) => props.theme.PRIMARY};
  border-radius: 5px;
  box-sizing: border-box;

  opacity: 0;
  overflow: hidden;
  line-height: 0;
`;

export const ConteinerPerfil = styled.div`
  position: relative;

  box-sizing: border-box;

  &::after {
    position: absolute;
    top: -25px;
    left: 50%;

    width: 0;
    height: 0;

    border: 12px solid;
    border-color: transparent transparent ${(props) => props.theme.PRIMARY} transparent;
    bottom: auto;

    content: '';
    transform: translateX(-50%);
  }
`;

export const Perfil = styled.a`
  color: ${(props) => props.theme.PRIMARY};
  font-size: 0.875rem;
  text-decoration: none;

  box-sizing: border-box;

  &:focus ~ ${ConteinerPerfis} {
    height: auto;
    padding: 5px 0px;

    opacity: 1;
    transition: opacity 0.5s ease-out;
    overflow: visible;
  }

  &:not(:focus) ~ ${ConteinerPerfis} {
    height: 0;

    opacity: 0;
    overflow: hidden;
  }
`;

export const ConteinerUsuario = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  box-sizing: border-box;
  padding: 0px 0.5rem;
`;

export const Opcao = styled.button`
  width: 100%;
  padding: 5px 10px;

  color: ${(props) => props.theme.LIGHT};
  background-color: ${(props) => props.theme.PRIMARY};
  border: none;
  outline: none;

  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.PRIMARY_DARKER};
  }

  &:active ~ ${ConteinerPerfis} {
    height: auto;
    padding: 5px 0px;

    opacity: 1;
    transition: opacity 0.5s ease-out;
    overflow: visible;
  }
`;
